import { Error } from './Error';
import { Loading } from './Loading';

export const AsyncWrapper: React.FC<{
  isLoading: boolean;
  error?: string | null;
  children: React.ReactNode;
}> = ({ isLoading, error, children }) => {
  return (
    <>{isLoading ? <Loading /> : error ? <Error error={error} /> : children}</>
  );
};
